export const LYG_MEMBERS_KEYS = {
  base: 'members',
  filtered: (filters: AnyObject): unknown[] => [LYG_MEMBERS_KEYS.base, filters],
  member: (id: number): unknown[] => [LYG_MEMBERS_KEYS.base, id],
};
